'use client';

import { Users, Handshake, School, Rocket, Lightbulb, Wallet2 } from "lucide-react";

const WISE_STATS = [
  { id: 1, icon: Users, value: "8500+", label: "Student Trainees" },
  { id: 2, icon: Handshake, value: "300+", label: "Industry Partners" },
  { id: 3, icon: School, value: "15+", label: "Schools & Centers" },
  { id: 4, icon: Rocket, value: "50+", label: "Programs" },
  { id: 5, icon: Lightbulb, value: "200+", label: "Subject Experts" },
  { id: 6, icon: Wallet2, value: "100%", label: "Learn & Earn" },
];

export function WiseSection() {
  return (
    <section className="relative py-12 md:py-16 lg:py-18 bg-gradient-to-b from-[#d9f0ff] via-[#cfe9fb] to-[#d9f0ff]">
      <div className="relative max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
        {/* Top content */}
        <div className="grid gap-8 lg:gap-12 lg:grid-cols-2 items-start mb-10 md:mb-12">
          <div>
            <p className="text-[11px] md:text-xs uppercase tracking-[0.2em] text-sky-700/70 mb-2">
              Work Integrated Skill-Based Higher Education
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900">
              Work Integrated Skill-
              <br className="hidden md:block" />
              Based Higher Education
              <span className="text-sky-800"> (WISE)</span>
            </h2>
          </div>

          <div className="text-sm md:text-base leading-relaxed text-sky-900/90">
            <p>
              WISE (Work Integrated Skill-Based Higher Education) by Medhavi
              Skills University offers work-integrated, practice-based programs
              with on-the-job training, apprenticeships, and stipends wherein
              industry partners co-develop the curriculum and provide hands-on
              training at their facilities.
            </p>
          </div>
        </div>

        {/* Stats cards */}
        <div className="rounded-3xl bg-sky-900/90 shadow-[0_18px_45px_rgba(15,23,42,0.18)] px-4 py-5 md:px-6 md:py-7 lg:px-8 lg:py-8">
          <div className="grid gap-3 md:gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
            {WISE_STATS.map((stat) => (
              <StatCard key={stat.id} icon={stat.icon} value={stat.value} label={stat.label} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function StatCard({ icon: Icon, value, label }) {
  return (
    <div className="group h-full">
      <div className="h-full rounded-2xl bg-sky-800/90 border border-sky-700/70 flex flex-col items-center justify-center px-3 py-4 md:px-4 md:py-5 text-center text-sky-50 transition transform duration-200 group-hover:-translate-y-1 group-hover:bg-sky-700/95 group-hover:shadow-[0_14px_32px_rgba(15,23,42,0.35)]">
        <div className="mb-3 flex items-center justify-center">
          <div className="flex h-10 w-10 md:h-11 md:w-11 items-center justify-center rounded-full bg-sky-600/40 border border-sky-400/70">
            <Icon className="h-5 w-5 md:h-6 md:w-6 text-white" />
          </div>
        </div>
        <div className="text-lg md:text-xl font-semibold">{value}</div>
        <div className="mt-1 text-xs md:text-sm text-sky-100/90">{label}</div>
      </div>
    </div>
  );
}
